export { default } from './ScoredCard'
